import { getURL } from '../../query';
import { getLaunchAppCommonParams, getLaunchAppEnv, forcePull, trackEvent, getDeepLink } from '../utils';
import { getLaunchAppStatus } from '../../webx';
const linkTypeToEventIdMap = {
    1: 'launch_app_passenger_btn_click',
    2: 'launch_app_passenger_btn_click',
    3: 'launch_app_mini_btn_click'
};
const showLaunchAppUi = (launchAppRes, phone, keyboardToken) => new Promise((resolve, reject) => {
    const { pullDescription, mainDeepLinks, pullFailMsg, pullFailDeepLinks, browser } = launchAppRes;
    let { waitTime } = mainDeepLinks[0];
    const link = getDeepLink(mainDeepLinks[0] || {});
    // 创建dom节点
    const rootView = document.createElement('div');
    const container = document.createElement('div');
    const titleText = document.createElement('div');
    const descText = document.createElement('div');
    const waitTextView = document.createElement('div');
    const waitText = document.createElement('span');
    const timerText = document.createElement('span');
    // 设置每个节点样式和内容
    titleText.innerText = '温馨提示';
    descText.innerText = pullDescription;
    waitText.innerText = '请稍后';
    timerText.innerText = `（${waitTime}s）`;
    // title 第一行文字 温馨提示
    titleText.style.color = '#353535';
    titleText.style.fontSize = '4.8vw';
    titleText.style.fontWeight = 'bold';
    // sub title 第二行文字 拉端描述信息
    descText.style.color = '#353535';
    descText.style.fontSize = '3.46vw';
    descText.style.fontWeight = '500';
    // 第三行文字 左边文字 请稍后
    waitText.style.color = '#FF7D41';
    waitText.style.fontSize = '3.73vw';
    waitText.style.fontWeight = 'bold';
    // 第三行文字 右边文字 (5s)
    timerText.style.color = '#505050';
    timerText.style.fontSize = '3.73vw';
    // 第三行文字父级元素对应dom
    waitTextView.style.display = 'flex';
    waitTextView.style.flexDirection = 'row';
    waitTextView.style.justifyContent = 'center';
    waitTextView.style.width = '100%';
    // 整个拉端蒙层对应的dom
    rootView.className = 'launch-app-wait-view';
    rootView.style.position = 'fixed';
    rootView.style.width = '100vw';
    rootView.style.height = '100vh';
    rootView.style.backgroundColor = 'rgba(0, 0, 0, .6)';
    rootView.style.zIndex = '9999';
    rootView.style.top = '0';
    rootView.style.left = '0';
    // 拉端半弹窗对应的dom
    container.style.boxSizing = 'border-box';
    container.style.position = 'fixed';
    container.style.zIndex = '9999';
    container.style.bottom = '0';
    container.style.left = '0';
    container.style.right = '0';
    container.style.margin = '0 auto';
    container.style.padding = '0 7.7vw';
    container.style.width = '96vw';
    container.style.height = '35.7vw';
    container.style.textAlign = 'center';
    container.style.backgroundColor = '#FFFFFF';
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.alignItems = 'center';
    container.style.justifyContent = 'space-around';
    container.style.borderRadius = '6vw 6vw 0 0';
    // 由子到父层级关系依次挂载节点
    waitTextView.appendChild(waitText);
    waitTextView.appendChild(timerText);
    container.appendChild(titleText);
    container.appendChild(descText);
    container.appendChild(waitTextView);
    rootView.appendChild(container);
    document.body.appendChild(rootView);
    // 埋点：弹窗曝光
    trackEvent('launch_app_force_pull_popup_expose');
    // 防止冒泡
    container.onclick = function (e) {
        e.stopPropagation && e.stopPropagation();
        // 兼容IE
        e.cancelBubble && (e.cancelBubble = true);
    };
    // 点击蒙层，移除提示
    rootView.onclick = function () {
        clearTimer();
        rootView.remove();
    };
    let timer = null;
    function clearTimer() {
        clearTimeout(timer);
        timer = null;
    }
    // 倒计时，倒计时结束后，查询拉端结果，如果拉端失败，展示拉端失败时的view
    timer = setInterval(async () => {
        timerText.innerText = `（${--waitTime}s）`;
        if (waitTime <= 0) {
            clearTimer();
            const params = {
                args: {
                    url: getURL(),
                    deeplink: link,
                    phone: phone || '',
                    keyboard_token: keyboardToken || ''
                },
                ...getLaunchAppCommonParams()
            };
            try {
                const res = await getLaunchAppStatus(params, getLaunchAppEnv());
                const { conf: { status } } = res;
                if (status === 1) {
                    rootView.remove();
                    resolve();
                }
                else {
                    setPullFailedView(browser);
                    reject();
                }
            }
            catch (error) {
                setPullFailedView(browser);
                reject();
                console.log('查询拉端接口出错：', error);
            }
        }
    }, 1000);
    // 设置拉端失败时的view
    function setPullFailedView(browser) {
        // 更新提示信息为拉端失败时的提示语
        descText.innerText = pullFailMsg;
        if (pullFailDeepLinks.length === 2) {
            container.style.alignItems = 'flex-start';
            waitTextView.style.justifyContent = 'space-between';
        }
        waitTextView.innerHTML = '';
        // 遍历数据创建候补拉端方式按钮，并为其添加点击拉端事件
        pullFailDeepLinks.forEach(link => {
            const linkBtn = document.createElement('div');
            linkBtn.innerText = link.buttonText;
            linkBtn.style.color = '#FF7D41';
            linkBtn.style.fontSize = '3.73vw';
            linkBtn.style.fontWeight = 'bold';
            waitTextView.appendChild(linkBtn);
            linkBtn.className = 'launch-app-btn';
            linkBtn.onclick = function () {
                // 如果点击口令拉端按钮，关闭该弹窗
                if (link.linkType === 6) {
                    rootView.remove();
                }
                const eventId = linkTypeToEventIdMap[link.linkType];
                eventId && trackEvent(eventId);
                forcePull(link, browser);
            };
        });
    }
});
export default showLaunchAppUi;
